/* global KmClbScriptMain */

class Utils {
  requestTimeout = 60000;

  errorAlert = (message) => {
    return `<div class="cls-flex cls-items-center cls-w-full cls-p-3 cls-mb-4 cls-text-sm cls-rounded-lg clb-alert cls-text-red-800 cls-bg-red-50" role="alert"><div>${message}</div></div>`;
  };

  // Never rejects: callers clear their loading state in .then() only,
  // so a thrown error would leave spinners running forever.
  ajaxRequest = async (action, ajaxData = {}, customScript = null) => {
    const { ajax } = customScript ? customScript : KmClbScriptMain;

    const formData = new FormData();
    formData.append('action', action);
    formData.append('security', ajax.nonce);

    Object.entries(ajaxData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = controller ? setTimeout(() => controller.abort(), this.requestTimeout) : null;

    try {
      const response = await fetch(ajax.url, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
        signal: controller ? controller.signal : undefined,
      });

      const body = await response.text();

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      try {
        return JSON.parse(body);
      } catch (parseError) {
        // Recover the payload when php notices or warnings are printed before it.
        const start = body.indexOf('{');

        if (start > 0) {
          return JSON.parse(body.slice(start));
        }

        throw parseError;
      }
    } catch (error) {
      console.error('KmClb ajax request failed', action, error);

      return {
        error: this.errorAlert('Something went wrong, please try again.'),
        requestFailed: true,
      };
    } finally {
      if (timer) {
        clearTimeout(timer);
      }
    }
  };

  numberFormat = (numberToFormat, decimals, decPoint, thousandsSep) => {
    const number = (numberToFormat + '').replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
    const dec = typeof decPoint === 'undefined' ? '.' : decPoint;
    let s = ''

    const toFixedFix = function (n, prec) {
      if (('' + n).indexOf('e') === -1) {
        return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
      } else {
        const arr = ('' + n).split('e');
        let sig = '';
        if (+arr[1] + prec > 0) {
          sig = '+';
        }
        return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
      }
    }

    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }

    return s.join(dec);
  }

  gaEvent = (eventName, eventData = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': eventName,
      ...eventData
    });
  }
}

export default new Utils();
